import {
  getGetNodoPortaleQueryOptions,
  NodoDto,
  useGetAziendePortale,
  useGetNodoPortale,
} from "@/api";
import { portaleConfig } from "@/portaliConfig";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useQueries } from "@tanstack/react-query";
import { Fragment, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

export type NodoPickerProps = {
  grow: "horizontally" | "vertically" | false;
  value: { id: number } | null;
  onChange: (path: NodoDto | null) => void;
  readOnly?: boolean;
  filterSelection?: (nodo: NodoDto) => boolean;
};

export function NodoPicker({
  grow,
  value: _value,
  onChange,
  readOnly = false,
  filterSelection = (n) => n.tipo === "Azienda" || n.tipo === "Contenitore",
}: NodoPickerProps) {
  const { t } = useTranslation();

  const { data: aziende, isLoading: loadingAziende } = useGetAziendePortale(
    portaleConfig.id
  );

  // // auto seleziono la prima azienda se è l'unica
  // useEffect(() => {
  //   if (!_value && !loadingAziende && aziende?.data) {
  //     if (aziende.data.length === 1) {
  //       onChange(aziende.data[0]);
  //     }
  //   }
  // }, [_value, aziende, loadingAziende]);

  const { data: value } = useGetNodoPortale(portaleConfig.id, _value?.id ?? 0, {
    query: {
      enabled: !!_value,
    },
  });

  const pathNodi = useMemo(() => {
    return [
      ...(value?.data?.breadcrumbs ?? []).map((b) => b.nodo),
      value?.data ? value.data : null,
    ].filter((x) => !!x) as NodoDto[];
  }, [value]);

  const nodi = useQueries({
    queries: pathNodi.map((n) => {
      return getGetNodoPortaleQueryOptions(portaleConfig.id, n.id);
    }),
  });

  const aziendaValue = value?.data
    ? aziende?.data?.find(
        (x) =>
          x?.id ===
          (value.data.tipo === "Azienda"
            ? value.data.id
            : value.data.breadcrumbs?.[0]?.nodo?.id ?? 0)
      ) ?? null
    : null;

  return (
    <Box
      display="flex"
      flexDirection={grow === "horizontally" ? "row" : "column"}
      gap={1}
    >
      {aziende?.data && aziende.data.length > 1 && (
        <Autocomplete<NodoDto>
          onChange={(event, x) => {
            onChange(x);
          }}
          value={aziendaValue}
          options={aziende.data}
          getOptionLabel={(n) => n.nome}
          isOptionEqualToValue={(option, value) =>
            value && option.id === value.id
          }
          renderInput={(params) => (
            <TextField {...params} placeholder={t("nodoPicker.placeholder.azienda")} />
          )}
          size="small"
          readOnly={readOnly}
        />
      )}

      {nodi.map((n, i) => {
        return (
          <Fragment key={n.data?.data?.id ?? i}>
            {n.data?.data &&
              (n.data.data.tipo === "Azienda" ||
                n.data.data.tipo === "Contenitore") && (
                <Autocomplete<NodoDto>
                  onChange={(event, x) => {
                    if (x) {
                      onChange(x);
                    } else {
                      onChange(nodi[i].data?.data ?? null);
                    }
                  }}
                  options={
                    n.data.data.nodiFigli?.filter((x) => filterSelection(x)) ??
                    []
                  }
                  getOptionLabel={(n) => n.nome}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  value={
                    pathNodi[i + 1]
                      ? nodi.find(
                          (x) => x.data?.data?.id === pathNodi?.[i + 1]?.id
                        )?.data?.data ?? null
                      : null
                  }
                  renderInput={(params) => <TextField {...params} />}
                  size="small"
                  readOnly={readOnly}
                />
              )}
          </Fragment>
        );
      })}
    </Box>
  );
}
